module.exports = __webpack_public_path__ + "img/IMG_0057_FoamcoreMatted.160448a7.jpg";